videojs.addLanguage('pl', {
  "Audio Player": "Odtwarzacz audio",
  "Video Player": "Odtwarzacz wideo",
  "Play": "Odtwarzaj",
  "Pause": "Pauza",
  "Replay": "Odtwórz ponownie",
  "Current Time": "Aktualny czas",
  "Duration": "Czas trwania",
  "Remaining Time": "Pozostały czas",
  "Stream Type": "Typ strumienia",
  "LIVE": "NA ŻYWO",
  "Loaded": "Załadowany",
  "Progress": "Status",
  "Progress Bar": "Pasek stanu",
  "Fullscreen": "Pełny ekran",
  "Non-Fullscreen": "Pełny ekran niedostępny",
  "Mute": "Wyłącz dźwięk",
  "Unmute": "Włącz dźwięk",
  "Playback Rate": "Szybkość odtwarzania",
  "Subtitles": "Napisy",
  "subtitles off": "Napisy wyłączone",
  "Captions": "Transkrypcja",
  "captions off": "Transkrypcja wyłączona",
  "Chapters": "Rozdziały",
  "Descriptions": "Opisy",
  "descriptions off": "Opisy wyłączone",
  "Audio Track": "Ścieżka audio",
  "Volume Level": "Poziom głośności",
  "You aborted the media playback": "Odtwarzanie zostało przerwane",
  "A network error caused the media download to fail part-way.": "Problemy z siecią spowodowały błąd przy pobieraniu materiału wideo.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Materiał wideo nie może być załadowany, ponieważ wystąpił problem z siecią lub format nie jest obsługiwany",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Odtwarzanie materiału wideo zostało przerwane z powodu uszkodzonego pliku wideo lub z powodu błędu funkcji, które nie są wspierane przez przeglądarkę.",
  "No compatible source was found for this media.": "Dla tego materiału wideo nie znaleziono kompatybilnego źródła.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Źródło jest zaszyfrowane i nie mamy kluczy do jego odszyfrowania.",
  "Play Video": "Odtwarzaj wideo",
  "Close": "Zamknij",
  "Close Modal Dialog": "Zamknij okno modala",
  "Modal Window": "Okno modala",
  "This is a modal window": "To jest okno modala",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Ten modal możesz zamknąć naciskając przycisk Escape albo wybierając przycisk Zamknij.",
  ", opens captions settings dialog": ", otwiera okno dialogowe ustawień transkrypcji",
  ", opens subtitles settings dialog": ", otwiera okno dialogowe napisów",
  ", opens descriptions settings dialog": ", otwiera okno dialogowe opisów",
  ", selected": ", zaznaczone",
  "captions settings": "ustawienia transkrypcji",
  "subtitles settings": "ustawienia napisów",
  "descriptions settings": "ustawienia opisów",
  "Text": "Tekst",
  "White": "Biały",
  "Black": "Czarny",
  "Red": "Czerwony",
  "Green": "Zielony",
  "Blue": "Niebieski",
  "Yellow": "Żółty",
  "Magenta": "Magenta",
  "Cyan": "Cyjan",
  "Background": "Tło",
  "Window": "Okno",
  "Transparent": "Przezroczysty",
  "Semi-Transparent": "Półprzezroczysty",
  "Opaque": "Nieprzezroczysty",
  "Font Size": "Rozmiar czcionki",
  "Text Edge Style": "Styl krawędzi tekstu",
  "None": "Brak",
  "Raised": "Podniesiony",
  "Depressed": "Obniżony",
  "Uniform": "Równomierny",
  "Dropshadow": "Cień",
  "Font Family": "Czcionka",
  "Reset": "Ustawienia domyślne",
  "restore all settings to the default values": "zresetuj wszystkie ustawienia do domyślnych wartości",
  "Done": "Gotowe",
  "Caption Settings Dialog": "Okno dialogowe ustawień transkrypcji",
  "Beginning of dialog window. Escape will cancel and close the window.": "Początek okna dialogowego. Escape anuluje i zamknie okno.",
  "End of dialog window.": "Koniec okna dialogowego.",
  "Exit Picture-in-Picture": "Wyjdź z trybu obraz w obrazie",
  "Picture-in-Picture": "Obraz w obrazie"
});